export function solve(people, days) {
    function makeAssigned(people, days, pool) {
        let gene = pool[0];
        let res = {};
        days.forEach((d) => {
            let assigned = {};
            people.forEach((p) => {
                let s = gene.people[p.key][d.key] || null;
                if (s == 'A' || s == 'a') {
                    assigned[p.key] = 'a';
                }
            })
            res[d.key] = assigned;
        })
        return res;
    }

    function generatePool(size, people, days) {
        let pool = [];
        for (let i = 0; i < size; i++) {
            pool.push(generateInitialGene(people, days));
        }
        return pool;
    }

    let pool = generatePool(500, people, days);
    for (let i = 0; i < 20; i++) {
        pool.forEach((gene) => {
            adjustAbsents(people, days, gene);
        })
        for (let j = 0; j < 10; j++) {
            crossover(people, days, pool);
        }
        for (let j = 0; j < 100; j++) {
            mutate(people, days, pool);
        }
        pool = sortPool(people, days, pool);
        pool = pool.slice(0, 500);
    }
    return makeAssigned(people, days, pool);
}


function sortPool(people, days, pool) {
    pool.forEach((gene) => {
        let newScore = 0;

        let dayStats = {};
        days.forEach((d) => {
            dayStats[d.key] = {
                editorAbsent: 0,
                reporterAbsent: 0,
            }
        })

        people.forEach((p) => {
            let absentCount = 0;
            let v = gene.people[p.key];
            for (let dk in v) {
                if (v[dk] == 'a' || v[dk] == 'A') {
                    absentCount++;
                    if (p.isReporter) { dayStats[dk].reporterAbsent++; }
                    if (p.isEditor) { dayStats[dk].editorAbsent++; }
                }
            }
            if (absentCount > p.absentTarget) {
                newScore -= (absentCount - p.absentTarget) * 100;
            } else if ((p.absentTarget - absentCount) >= 0) {
                newScore -= (p.absentTarget - absentCount) * 100;
            }
        })

        days.forEach((d) => {
            let numE = d.sumPeople.editor - dayStats[d.key].editorAbsent;
            if (numE < d.minEditor) {
                newScore -= (d.minEditor - numE) * 500;
            }
            let numR = d.sumPeople.reporter - dayStats[d.key].reporterAbsent;
            if (numR < d.minReporter) {
                newScore -= (d.minReporter - numR) * 100;
            }
            if (numR > d.maxReporter) {
                newScore -= (numR - d.maxReporter) * 100;
            }
        })

        const wsize = 7;
        people.forEach((p) => {
            let vector = gene.people[p.key];
            let s = 0;
            let ws = 0;
            for (let i = 0; i < days.length; i++) {
                let a = vector[days[i].key];
                if (a == 'A' || a == 'a') {
                    s += 1;
                } else {
                    ws += 1;
                }
                if (i >= wsize) {
                    let b = vector[days[i - wsize].key];
                    if (b == 'A' || b == 'a') {
                        s -= 1;
                    } else {
                        ws -= 1;
                    }
                }
                if (i >= wsize - 1) {
                    if (s / wsize > 0.4) {
                        newScore -= s / wsize * 10;
                    }
                    if (ws >= 6) {
                        newScore -= (ws - 5) * 10;
                    }
                }
            }
        })

        gene.score = newScore;
    })

    return pool.sort((a, b) => b.score - a.score);
}


function mutate(people, days, pool) {
    let base_gene = pool[Math.floor(Math.random() * pool.length)];
    let new_gene = JSON.parse(JSON.stringify(base_gene));
    let p = people[Math.floor(Math.random() * people.length)];
    let vector = new_gene.people[p.key];
    let absent = [];
    let work = [];
    days.forEach((d) => {
        if (vector[d.key] == 'a') { absent.push(d.key); }
        if (vector[d.key] == undefined) { work.push(d.key); }
    })
    if (absent.length != 0 && work.length != 0) {
        let a = absent[Math.floor(Math.random() * absent.length)];
        let w = work[Math.floor(Math.random() * work.length)];
        vector[w] = 'a';
        delete vector[a];
        pool.push(new_gene);
    }
}

function crossover(people, days, pool) {
    let gene_a = pool[Math.floor(Math.random() * pool.length)];
    let gene_b = pool[Math.floor(Math.random() * pool.length)];
    let person = people[Math.floor(Math.random() * people.length)];
    let gene_c = JSON.parse(JSON.stringify(gene_a));
    gene_c.score = null;
    gene_c.people[person.key] = gene_b.people[person.key];
    let gene_d = JSON.parse(JSON.stringify(gene_b));
    gene_d.score = null;
    gene_d.people[person.key] = gene_a.people[person.key];
    pool.push(gene_c);
    pool.push(gene_d);
}

function adjustAbsents(people, days, gene) {
    people.forEach((p) => {
        let v = gene.people[p.key];
        let count = 0;
        for (let dk in v) {
            if (v[dk] == 'a' || v[dk] == 'A') {
                count++;
            }
        }
        if (count < p.absentTarget) {
            let dk = days[Math.floor(Math.random() * days.length)].key;
            v[dk] = v[dk] || 'a';
        } else if (count > p.absentTarget) {
            let dk = days[Math.floor(Math.random() * days.length)].key;
            if (v[dk] == 'a') {
                delete v[dk];
            }
        }
    });
}


function generateInitialGene(people, days) {
    let gene = {
        people: {},
        score: null,
    };
    people.forEach((p) => {
        let vector = {};
        days.forEach((d) => {
            let assigned = d.assigned || {};
            if (assigned[p.key] == 'a') {
                vector[d.key] = 'a';
            }

            let preferred = d.preferred || {};
            if (preferred[p.key] == 'A') {
                vector[d.key] = 'A';
            } else if (preferred[p.key] == 'W') {
                vector[d.key] = 'W';
            }

            gene.people[p.key] = vector;
        })
    })
    return gene;
}



// WEBPACK FOOTER //
// ./src/solver.js